import { Method } from 'axios';
import {
  GeoLocation,
  WalletPass,
  WalletPassData,
  WalletPassInput,
  WalletPerson,
} from './interfaces';
import { Executable } from './executable';

export class IssueWallet extends Executable<WalletPass> implements Partial<WalletPassInput> {
  public brandId?: number;

  public programId?: number;

  public passdata?: WalletPassData;

  /**
   * The person record.
   */
  public person?: WalletPerson;

  /**
   * The current message that is displayed on the wallet pass.
   */
  public currentMessage?: string;

  /**
   * The tier to put the card in during creation, if not provided will use the default tier.
   */
  public templateTierId?: number;

  /**
   * The location from which the card is being issued.
   */
  public geoLocation?: GeoLocation;

  /**
   * The ipaddress which is requesting the card to be issued.
   */
  public ipAddress?: string;

  /**
   * The templateId from which the card is being issued.  If a program is provided, this is not required.
   */
  public templateId?: number;

  public getMethod(): Method {
    return 'post';
  }

  public getResponse(apiResponse: any): WalletPass {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId && !this.templateId) throw new Error('programId or templateId is required');
    if (this.programId) {
      return `${this.brandId}/programs/${this.programId}/issue-wallet`;
    }
    return `${this.brandId}/issue-wallet`;
  }

  constructor(input?: Partial<WalletPassInput> & { brandId: number }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<WalletPassInput> {
    return {
      person: this.person,
      passdata: this.passdata,
      templateId: this.templateId,
      templateTierId: this.templateTierId,
      currentMessage: this.currentMessage,
      geoLocation: this.geoLocation,
      ipAddress: this.ipAddress,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
